var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarnicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8276 40.0781C25.8276 40.7868 26.1091 41.4664 26.6102 41.9674C27.1112 42.4685 27.7908 42.75 28.4995 42.75C29.2081 42.75 29.8877 42.4685 30.3888 41.9674C30.8898 41.4664 31.1713 40.7868 31.1713 40.0781C31.1713 39.3695 30.8898 38.6899 30.3888 38.1888C29.8877 37.6878 29.2081 37.4062 28.4995 37.4062C27.7908 37.4062 27.1112 37.6878 26.6102 38.1888C26.1091 38.6899 25.8276 39.3695 25.8276 40.0781ZM26.7182 23.1562V33.3984C26.7182 33.6434 26.9186 33.8438 27.1635 33.8438H29.8354C30.0803 33.8438 30.2807 33.6434 30.2807 33.3984V23.1562C30.2807 22.9113 30.0803 22.7109 29.8354 22.7109H27.1635C26.9186 22.7109 26.7182 22.9113 26.7182 23.1562ZM53.1976 47.6484L30.0414 7.57031C29.6962 6.97471 29.1006 6.67969 28.4995 6.67969C27.8983 6.67969 27.2971 6.97471 26.9576 7.57031L3.80131 47.6484C3.11664 48.8396 3.97387 50.3203 5.34321 50.3203H51.6557C53.025 50.3203 53.8823 48.8396 53.1976 47.6484ZM9.58481 46.0954L28.4995 13.3538L47.4141 46.0954H9.58481Z",
    fill: "#0075FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnicon);
export default __webpack_public_path__ + "static/media/warnicon.2dbf037c9ecc36ede3437b13a187b825.svg";
export { ForwardRef as ReactComponent };